import FenixProvider from '@pedidosya/web-fenix/contexts/FenixContext';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';
import { Provider } from 'react-redux';
import ErrorBoundary from '../components/ErrorBoundary';
import FilterProvider from '../providers/FilterProvider';
import WindowProvider from '../providers/WindowProvider';
import { useStore } from '../redux/store';
import GlobalStyleSheet from '../styles/globalStyleSheet';
import customTheme from '../theme';
import { isIOS } from '../utils/userAgent';

const Error = dynamic(() => import('../components/Error'));

const MessagesContext = createContext();

function App({ Component, pageProps }) {
  const { initialState, i18n: { messages } = {} } = pageProps;

  const store = useStore(initialState);

  const theme = {
    ...customTheme,
  };

  const country = initialState?.country?.shortName;

  return (
    <>
      <Head>
        <title>Generic Landings</title>
        <meta
          name="viewport"
          content="viewport-fit=cover, width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta name="theme-color" content="#fa0050" />
      </Head>
      <MessagesContext.Provider value={messages}>
        <Provider store={store}>
          <FenixProvider
            country={country}
            customTheme={theme}
            config={{ fenixVersion: initialState?.shared?.fenixVersion }}
          >
            <GlobalStyleSheet
              isDesktop={initialState?.shared?.platform === 'desktop'}
              isios={isIOS(initialState?.shared?.platform)} //  Importante para manejar espaciado en iphones safe area navbar etiqueta header
            />
            <WindowProvider>
              <FilterProvider>
                <ErrorBoundary fallback={<Error />}>
                  <Component {...pageProps} />
                </ErrorBoundary>
              </FilterProvider>
            </WindowProvider>
          </FenixProvider>
        </Provider>
      </MessagesContext.Provider>
    </>
  );
}

App.propTypes = {
  Component: PropTypes.elementType.isRequired,
  pageProps: PropTypes.shape({
    initialState: PropTypes.shape({}),
    fwfConfig: PropTypes.shape({}),
    trackerConfig: PropTypes.shape({}),
    i18n: PropTypes.shape({
      locale: PropTypes.string,
      messages: PropTypes.shape({}),
    }),
  }),
};

App.defaultProps = {
  pageProps: {},
};

export const useMessages = () => useContext(MessagesContext);
export default App;
